import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import EmployeeImportDataResultFile from "../model/EmployeeImportDataResultFile";

const DownloadEmployeeImportDataResultFileApiService = async (
  request: number
): Promise<EmployeeImportDataResultFile> => {
  const uri = `/employeeimportfiles/${request}/download/`;
  const { data } = await axios.post(uri);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDownloadEmployeeImportDataResultFileApiService = () =>
  useMutation<EmployeeImportDataResultFile, AxiosError, number>(
    "DownloadEmployeeImportDataResultFileApiService",
    DownloadEmployeeImportDataResultFileApiService
  );

export default useDownloadEmployeeImportDataResultFileApiService;
